/* eslint-disable max-lines */

import { Slide, Templates } from '@/types/slides'

export const templates:Templates[] = []

export const layouts: Slide[] = []